export default class DateModifier {
  public static getMilliSecondsAgo(date: Date) {
    const currentDate = new Date().getTime();

    const initialDate = date.getTime();

    return currentDate - initialDate;
  }
}
